export default __webpack_public_path__ + "static/media/olmos.313d2534.png";